window.Components = {}



// WEBPACK FOOTER //
// ./app/javascript/packs/init.js